/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `ACUTE_CARE_HOSPITAL` - Acute Care Hospital
 * * `ASC` - ASC
 * * `BEHAVIORAL_HEALTH_HOSPITAL` - Behavioral Health Hospital
 * * `CLINIC` - Clinic
 * * `CRITICAL_ACCESS_HOSPITAL` - Critical Access Hospital
 * * `FREE_STANDING_ER` - Free-standing ER
 * * `LTAC` - LTAC
 * * `REHAB` - Rehab
 * * `SNF` - SNF
 * * `TELEHEALTH` - Telehealth
 * * `URGENT CARE` - Urgent Care
 * * `OTHER` - other
 */
export enum FacilityTypeEnum {
    ACUTE_CARE_HOSPITAL = 'ACUTE_CARE_HOSPITAL',
    ASC = 'ASC',
    BEHAVIORAL_HEALTH_HOSPITAL = 'BEHAVIORAL_HEALTH_HOSPITAL',
    CLINIC = 'CLINIC',
    CRITICAL_ACCESS_HOSPITAL = 'CRITICAL_ACCESS_HOSPITAL',
    FREE_STANDING_ER = 'FREE_STANDING_ER',
    LTAC = 'LTAC',
    REHAB = 'REHAB',
    SNF = 'SNF',
    TELEHEALTH = 'TELEHEALTH',
    URGENT_CARE = 'URGENT CARE',
    OTHER = 'OTHER',
}
